// material ui icons
import RssFeedRoundedIcon from '@mui/icons-material/RssFeedRounded';

// material ui
import { Box } from '@mui/material';

// components
import bravida from '@/assets/bravida_logo_rgb_pos.png';

const renderControlType = (controlType) => {
  switch (controlType) {
    case 'ecl':
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <span>{controlType.toUpperCase()}</span>
          <RssFeedRoundedIcon />
        </Box>
      );
    case 'shelly':
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <span>{controlType.toUpperCase()}</span>
        </Box>
      );
    case 'pct':
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <span>{controlType.toUpperCase()}</span>
          <div
            style={{
              width: '25px',
              height: '25px',
              backgroundColor: '#323232',
              borderRadius: '40%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginRight: '0.5em',
            }}
          >
            <div
              style={{
                width: '12px',
                height: '12px',
                border: '1.5px solid #fff',
                // border: '1.5px solid #AEF359',
                borderRadius: '50%',
              }}
            ></div>
          </div>
        </Box>
      );
    case 'bravida':
      return (
        <Box sx={{ display: 'flex', width: '100%', height: '100%' }}>
          <img src={bravida} alt="Bravida Logo" style={{ height: '48px' }} />
        </Box>
      );
    default:
      return 'Unknown Control';
  }
};

const ControlTypeDisplay = ({ controlType }) => {
  return <div>{renderControlType(controlType)}</div>;
};

export default ControlTypeDisplay;
